import SchoolGroupsPage from './SchoolGroups.page';

export default SchoolGroupsPage;
